import React from 'react'
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const headRows = [
    {
      id: "organisation_name",
      numeric: true,
      disablePadding: true,
      label: "Organisation Name",
    },
    {
      id: "domain",
      numeric: false,
      disablePadding: true,
      label: "Domain",
    },
    // {
    //   id: "key_account_manager_name",
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Key Account Manager Name",
    // },
    // {
    //   id: "key_account_manager_email",
    //   numeric: true,
    //   disablePadding: false,
    //   label: "Key Account Manager Email",
    // },
    {
      id: "engineer_manager_name",
      numeric: true,
      disablePadding: true,
      label: "Engineer Manager Name",
    },
    {
      id: "engineer_manager_email",
      numeric: true,
      disablePadding: true,
      label: "Engineer Manager Email",
    },
    {
        id: "action", 
        numeric: true, 
        disablePadding: true, 
        label: "Action" 
    },
  ];

  
const EnhancedTableHead = (props) => {

    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <>
           <TableHead>
      <TableRow>
      <TableCell >
          Sr.No
      </TableCell>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.numeric ? "left" : "left"}
            padding={row.disablePadding ? "none" : "default"}
            sortDirection={orderBy === row.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === row.id}
              direction={order}
              onClick={createSortHandler(row.id)}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead> 
        </>
    )
}

export default EnhancedTableHead
